export const SET_BESTS = "SET_BESTS";
export const SET_BESTS_HISTORY = "SET_BESTS_HISTORY";
export const UPDATE_BEST = "UPDATE_BEST";
export const CLOSE_BEST = "CLOSE_BEST";
export const REMOVE_BEST = "REMOVE_BEST";
